"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingChart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const styled_1 = require("@framework/styled");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_user_1 = require("@dzambalaorg/provider-user");
const utils_1 = require("../../../../../utils");
const search_1 = require("./search");
const schemas_1 = require("./schemas");
const STAKING_CHART_URL = "/staking/chart";
const StakingChart = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return (0, schemas_1.stakingChartSearchValuesCreator)(profile)[service];
    }, [service, profile]);
    const { isLoading, allRows } = (0, react_hooks_1.useFetchQuery)(STAKING_CHART_URL, void 0, void 0, initialSearchValues);
    const chartRef = (0, react_1.useRef)(null);
    const [recentDeposits, setRecentDeposits] = (0, react_1.useState)(false);
    const handleSwitchDeposit = () => {
        setRecentDeposits(value => !value);
    };
    const clearChart = (0, react_1.useCallback)(() => {
        while (chartRef.current?.lastChild) {
            chartRef.current.removeChild(chartRef.current.lastChild);
        }
    }, [chartRef.current]);
    (0, react_1.useEffect)(() => {
        if (!chartRef.current) {
            return;
        }
        if (!allRows.length) {
            clearChart();
        }
        else {
            (0, utils_1.chartCreator)(chartRef, allRows, clearChart, recentDeposits);
        }
    }, [recentDeposits, chartRef.current, allRows]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "staking", "staking.chart"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.staking.chart.title" }), (0, jsx_runtime_1.jsx)(search_1.StakingChartSearchForm, { service: service, initialSearchValues: initialSearchValues, recentDeposits: recentDeposits, handleSwitchDeposit: handleSwitchDeposit }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledEmptyWrapper, { count: allRows.length, isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { mt: 4, mb: 2 }, width: "100%", ref: chartRef }) }) })] }));
};
exports.StakingChart = StakingChart;
//# sourceMappingURL=index.js.map